import { useNavigationContainerRef, useRouter } from 'expo-router'
import React, { useEffect } from 'react'

export const useSafeSetParams = () => {
  const [params, setParams] = React.useState<Record<string, string | string[] | undefined>>()
  const { isReady, addListener } = useNavigationContainerRef()
  const router = useRouter()

  const safeSetParams = (newParams: Record<string, string | string[] | undefined>) => {
    if (isReady()) {
      router.setParams(newParams)
    } else {
      setParams(newParams)
    }
  }

  useEffect(() => {
    let unsubscribe: VoidFunction | undefined

    if (params) {
      unsubscribe = addListener('ready', () => {
        router.setParams(params)
        setParams(() => undefined)
      })
    }

    return () => unsubscribe?.()
  }, [addListener, params, router])

  return { safeSetParams }
}
